
import SearchBar from '@/components/common/SearchBar'
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import { computed, onBeforeMount, reactive, ref, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import TableSelectInfo from '@/components/common/TableSelectInfo'

import { getTags } from '@/services/common'
import {
  getOfficialSheetSongs,
  deleteOfficialSheetSong,
  copySheetSong,
  batchSetSheetSongProduction,
  batchSetSheetSongTest,
  setSheetSongStatus
} from '@/services/songs'
import { debounce } from '@/utils/common'
import { PermissionMap } from '@/utils/auth'
import SelectBookModal from '@/views/songs/components/SelectBookModal'
import { statusMap } from '@/utils/dataMap'
import { songType, songSheetType } from '@/utils/dataMap/song'

export default {
  name: 'List',
  components: {
    TableSelectInfo,
    SearchBar,
    DownOutlined,
    UpOutlined,
    SelectBookModal
  },
  setup () {
    const modalRef = ref()
    const router = useRouter()
    const pageData = reactive({
      type: 1,
      firstLoading: true,
      advanced: false,
      tagParams: {
        pageSize: 50,
        page: 1,
        keyword: ''
      },
      modalVisible: false
    })

    const formState = reactive({
      name: '',
      song_type: -1,
      book_section_id: [],
      song_code: '',
      py: '',
      status: -1,
      tag: []
    })
    const formOpts = reactive({
      status: [{ label: '全部', value: -1 }],
      song_type: [{ label: '全部', value: -1 }],
      bookOptions: [],
      bookOpts: {
        showName: '教材名称-章节目录'
      },
      defaultBookOpts: {
        showName: '教材名称-章节目录'
      }
    })

    const tableState = reactive({
      selectedRowKeys: [],
      data: [],
      columns: [],
      loading: true,
      pagination: {
        showSizeChanger: true,
        current: 1,
        total: 1,
        pageSize: 10,
        showTotal: total => `共${total}条`,
        showQuickJumper: true
      }
    })

    const hasSelected = computed(() => tableState.selectedRowKeys.length > 0)

    const onSelectChange = selectedRowKeys => {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      tableState.selectedRowKeys = selectedRowKeys
    }

    tableState.columns = [
      {
        title: '歌曲名称',
        dataIndex: 'name',
        ellipsis: true,
        width: 200
      },
      {
        title: '歌曲识别码',
        dataIndex: 'song_code',
        width: 140
      },
      {
        title: '教材',
        dataIndex: 'book.name',
        width: 140,
        ellipsis: true
      },
      {
        title: '教材出版社',
        dataIndex: 'book.press_version.name',
        ellipsis: true,
        width: 140
      },
      {
        title: '章节',
        dataIndex: 'section_breadcrumb',
        width: 180,
        ellipsis: true
      },
      {
        title: '制作者',
        dataIndex: 'author_name',
        width: 120,
        ellipsis: true
      },
      {
        title: '歌曲简拼',
        dataIndex: 'py',
        width: 100,
        ellipsis: true
      },
      {
        title: '歌曲类型',
        dataIndex: 'song_type',
        width: 120,
        ellipsis: true,
        slots: { customRender: 'song_type' }
      },
      {
        title: '谱例类型',
        dataIndex: 'sheet_type',
        width: 120,
        ellipsis: true,
        slots: { customRender: 'sheet_type' }
      },
      {
        title: '标签',
        dataIndex: 'tags',
        width: 200,
        ellipsis: true,
        slots: { customRender: 'tags' }
      },
      {
        title: '状态',
        dataIndex: 'status',
        width: 120,
        ellipsis: true,
        slots: { customRender: 'status' }
      },
      {
        title: '创建时间',
        dataIndex: 'created_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '修改时间',
        dataIndex: 'updated_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 380,
        slots: { customRender: 'action' }
      }
    ]

    const getList = debounce(async (params) => {
      tableState.loading = true
      params = { ...queryParams.value, page: 1, ...params }
      const { items, pagination } = await getOfficialSheetSongs(params)
      tableState.data = items
      tableState.loading = false
      tableState.pagination = { ...tableState.pagination, ...pagination }
    })

    const handleTableChange = (pag) => {
      tableState.pagination = pag
      getList({ page: tableState.pagination.current })
    }

    const queryParams = computed(() => {
      const params = { ...formState }
      if (params.song_type === -1) {
        delete params.song_type
      }
      if (params.song_code === '') {
        delete params.song_code
      }
      if (params.book_section_id.length === 0) {
        delete params.book_section_id
      } else if (params.book_section_id.length === 1) {
        params.book_id = params.book_section_id[0]
        delete params.book_section_id
      } else {
        params.book_id = params.book_section_id[0]
        params.book_section_id = params.book_section_id[params.book_section_id.length - 1]
      }
      for (const key in params) {
        if (params[key] === '' || (key === 'status' && params[key] === -1)) {
          delete params[key]
        }
      }
      params.per_page = tableState.pagination.pageSize
      params.page = tableState.pagination.current
      return params
    })

    const getTagsOptions = debounce(async () => {
      const params = {
        per_page: pageData.tagParams.pageSize,
        current: pageData.tagParams.page,
        keyword: pageData.tagParams.keyword
      }
      formOpts.tags = (await getTags(params)).items.map(i => {
        i.label = i.tag
        i.value = i.tag
        return i
      })
    })

    const handleDelete = async (record) => {
      await deleteOfficialSheetSong(record.id)
      message.success('删除成功')
      getList({ page: tableState.pagination.current })
      console.log(record)
    }

    const handleCreate = async () => {
      router.push(`/resource/sheet-songs/create/${pageData.type}`)
    }

    const handleReset = () => {
      modalRef.value.handleReset()
      formState.status = -1
      formState.name = ''
      formState.song_type = -1
      formState.book_section_id = []
      formState.song_code = ''
      formState.py = ''
      formState.tag = []
      formOpts.bookOpts.showName = formOpts.defaultBookOpts.showName
      tableState.pagination.current = 1
      getTagsOptions()
      getList()
    }

    const handleSelectBookSection = (value) => {
      pageData.modalVisible = false
      if (value.values.length > 0) {
        formOpts.bookOpts.showName = value.labels.join('-')
        formState.book_section_id = value.values
      } else {
        formOpts.bookOpts.showName = formOpts.defaultBookOpts.showName
      }
      getList()
    }

    const handleTagSearch = v => {
      pageData.tagParams.page = 1
      pageData.tagParams.keyword = v
      getTagsOptions()
    }

    const handleTypeChange = () => {
      getList()
      getTagsOptions()
    }

    const handleCopy = async (record) => {
      const key = 'copy'
      try {
        await copySheetSong(record.id)
        message.loading({
          key,
          content: '正在处理'
        })
        message.success({
          key,
          content: '复制成功'
        })
      } catch (e) {
        message.error({
          key,
          content: '操作失败'
        })
      }
    }

    const handlePublish = async () => {
      if (!tableState.selectedRowKeys.length) {
        message.warning('请选择歌曲')
        return
      }
      await batchSetSheetSongProduction({ sheet_song_ids: tableState.selectedRowKeys })
      message.success('操作成功')
      tableState.selectedRowKeys = []
      getList()
    }

    const handlePublishTest = async () => {
      if (!tableState.selectedRowKeys.length) {
        message.warning('请选择歌曲')
        return
      }
      await batchSetSheetSongTest({ sheet_song_ids: tableState.selectedRowKeys })
      message.success('操作成功')
      tableState.selectedRowKeys = []
      getList()
    }

    const handleSetStatus = async (id, status) => {
      await setSheetSongStatus(id, { status })
      message.success('设置成功')
      getList({ page: tableState.pagination.current })
    }

    onBeforeMount(async () => {
      for (const k in statusMap) {
        formOpts.status.push({ value: k, label: statusMap[k].name })
      }
      for (const [k, v] of songType) {
        formOpts.song_type.push({ value: k, label: songType.get(k).name })
      }
      await Promise.all([
        getList(),
        getTagsOptions()
      ])
      pageData.firstLoading = false
    })

    onActivated(() => {
      getList({ page: tableState.pagination.current })
    })

    return {
      songType,
      songSheetType,
      statusMap,
      modalRef,
      pageData,
      formState,
      formOpts,
      tableState,
      getList,
      PermissionMap,
      hasSelected,
      router,
      handleTableChange,
      handleDelete,
      handleReset,
      handleCreate,
      handleTagSearch,
      handleSelectBookSection,
      handleTypeChange,
      handleCopy,
      onSelectChange,
      handlePublish,
      handlePublishTest,
      handleSetStatus
    }
  }
}
